import { getEwssGradeFromGameEntry } from "./ewssRetention";

export const LAST_GAME_PLAY_BUCKETS = [
  {
    id: "never",
    label: "Jamais joué au moment du jeu",
    match: (gameCountAtMoment) => gameCountAtMoment <= 0,
  },
  {
    id: "once",
    label: "Joués 1 fois au moment du jeu",
    match: (gameCountAtMoment) => gameCountAtMoment === 1,
  },
  {
    id: "twice",
    label: "Joué 2 fois au moment du jeu",
    match: (gameCountAtMoment) => gameCountAtMoment === 2,
  },
  {
    id: "threePlus",
    label: "Joué plus de 3 fois au moment du jeu",
    match: (gameCountAtMoment) => gameCountAtMoment >= 3,
  },
];

export function buildLastGameCellsFromGames(last5Games = []) {
  return [...last5Games]
    .sort((a, b) => {
      const parseDate = (dateStr) => {
        if (!dateStr) return 0;
        const [day, month, year] = dateStr.split("/").map(Number);
        return new Date(year, month - 1, day).getTime();
      };
      const parseTime = (timeStr) => {
        if (!timeStr) return 0;
        const [hh, mm] = timeStr.split(":").map(Number);
        return (hh || 0) * 60 + (mm || 0);
      };
      const dateDiff = parseDate(a.date) - parseDate(b.date);
      if (dateDiff !== 0) return dateDiff;
      return parseTime(a.time) - parseTime(b.time);
    })
    .map((entry) => ({
      result: entry.result === "success" ? "success" : "fail",
      gradeAfter: getEwssGradeFromGameEntry(entry),
    }));
}

export function groupLastGameWordInsights(wordInsights = []) {
  const groups = LAST_GAME_PLAY_BUCKETS.map((bucket) => ({
    ...bucket,
    words: [],
  }));

  for (const insight of wordInsights) {
    if (!insight?.mot) continue;
    const bucket = groups.find((entry) =>
      entry.match(Number(insight.gameCountAtMoment) || 0)
    );
    if (bucket) bucket.words.push(insight);
  }

  return groups;
}
